import { ChangeDetectionStrategy, Component, effect, ElementRef, inject, input } from '@angular/core';
import { WindowStore } from '../window-tabs/window.store';
import { CustomerListService } from '../../../07_feature/customer/customer.service';
import { MobileService } from '../../../01_core/services/mobile-service';

@Component({
  selector: 'tps-window-context',
  imports: [],
  templateUrl: './window-context.component.html',
  styleUrl: './window-context.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    MobileService,
    CustomerListService,
  ],
})
export class WindowContextComponent {

  elementRef = inject(ElementRef<HTMLElement>);
  mobileService = inject(MobileService);
  windowIndex = input.required<number>();
  tabIndex = input.required<number>();
  windowStore = inject(WindowStore);

  constructor() {
    effect(() => {
      const window = this.windowStore.windows()[this.windowIndex()];
    });
  }

  onClick() {
    this.windowStore.setWindowActive(this.windowIndex());
  }

  ngAfterViewChecked(): void {
    if (this.elementRef.nativeElement.offsetWidth <= 600) {
      this.mobileService.setMobileOverride(true);
    } else {
      this.mobileService.setMobileOverride(null);
    }
  }

  onResize(event: UIEvent) {}
}
